import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import histogramInit from 'highcharts/modules/histogram-bellcurve'
import stockInit from 'highcharts/modules/stock'
import More from 'highcharts/highcharts-more'
import Gauge from 'highcharts/modules/solid-gauge'
import exportingInit from 'highcharts/modules/exporting'
import offlineExporting from 'highcharts/modules/offline-exporting'

More(Highcharts)
Gauge(Highcharts)
exportingInit(Highcharts)
offlineExporting(Highcharts)
histogramInit(Highcharts)
stockInit(Highcharts)

Vue.use(HighchartsVue)
